import { render, staticRenderFns } from "./newInvisit.vue?vue&type=template&id=cf7108ae&scoped=true&name=newInvisit&"
import script from "./newInvisit.vue?vue&type=script&lang=js&"
export * from "./newInvisit.vue?vue&type=script&lang=js&"
import style0 from "./newInvisit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./newInvisit.vue?vue&type=style&index=1&id=cf7108ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7108ae",
  null
  
)

export default component.exports